import { render, staticRenderFns } from "./AdminVehicleEntity.vue?vue&type=template&id=b0fa1a4c&"
import script from "./AdminVehicleEntity.vue?vue&type=script&lang=js&"
export * from "./AdminVehicleEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0fa1a4c')) {
      api.createRecord('b0fa1a4c', component.options)
    } else {
      api.reload('b0fa1a4c', component.options)
    }
    module.hot.accept("./AdminVehicleEntity.vue?vue&type=template&id=b0fa1a4c&", function () {
      api.rerender('b0fa1a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminVehicleEntity.vue"
export default component.exports